import { WebLayout } from "../components";
import Brands from "../pages/Brands";
import DashboardIndex from "../pages/DashboardIndex";
import Error404 from "../pages/Error404";
import CustomerList from "../pages/CustomerList";
import CustomerDetail from "../pages/CustomerDetail";
import BrandForm from "../pages/BrandForm";
// import NotFound from "../pages/NotFound";
import OrderDetails from "../pages/OrderDetails";
import OrderList1 from "../pages/OrderList1";
import OrderList2 from "../pages/OrderList2";
import ProductCategory from "../pages/ProductCategory";
import ProductCategoryEdit from "../pages/ProductCategoryEdit";
import Products from "../pages/Products";
import Reviews from "../pages/Reviews";
import Settings from "../pages/Settings";
import EditAccount from "../pages/EditAccount";
import Transactions from "../pages/Transactions";
import UserLogin from "../pages/UserLogin";
import UserRegistration from "../pages/UserRegistration";
import { ErrorBoundary } from "../utils";
import ProductGrid from "../pages/ProductGrid";
import AddProducts from "../pages/AddProducts";
import EditProduct from "../pages/EditProduct";
import CategoryForm from "../pages/CategoryForm";
import Categories from "../pages/Categories";
import Delivery from "../pages/Delivery";
import UpdateCategoryForm from "../pages/UpdateCategoryForm";
import ViewCategoryForm from "../pages/ViewCategoryForm";
import TransactionDetails from "../pages/TransactionDetails";
import AdminManagement from "../pages/AdminManagement";
import Banners from "../pages/Banners";
import BNPLReqs from "../pages/Bnpl";
import Cart from "../pages/Cart";
import Tracker from "../pages/Tracker";
import HomeLayout from "../pages/HomeLayout";
import MonthlyEarnings from "../pages/MonthlyEarnings";

export const PrivateRoute = () => {
  return {
    errorElement: <ErrorBoundary />,
    hasErrorBoundary: true,
    children: [
      {
        element: <WebLayout />,
        children: [
          {
            path: "admin-dashboard",
            element: <DashboardIndex />,
          },
          {
            path: "products",
            element: <Products />,
          },
          {
            path: "product-grid",
            element: <ProductGrid />,
          },
          {
            path: "add-product",
            element: <AddProducts />,
          },
          {
            path: "product-category",
            element: <ProductCategory />,
          },
          {
            path: "product-category-edit/:id",
            element: <ProductCategoryEdit />,
          },
          {
            path: "edit-product/:id",
            element: <EditProduct />,
          },
          {
            path: "orders",
            element: <OrderList1 />,
          },
          {
            path: "delivery",
            element: <Delivery />,
          },
          {
            path: "orderlist-2",
            element: <OrderList2 />,
          },
          {
            path: "order/details/:orderId",
            element: <OrderDetails />,
          },
          {
            path: "admin-dashboard/bnpl",
            element: <BNPLReqs />,
          },
          {
            path: "admin-dashboard/bnpl/details/:bnplId",
            element: <Transactions />, //bnpl details
          },
          {
            path: "admin-dashboard/tracker/cart",
            element: <Cart />,
          },
          {
            path: "admin-dashboard/tracker",
            element: <Tracker />,
          },
          {
            path: "admin-dashboard/monthly-earnings",
            element: <MonthlyEarnings />,
          },
          {
            path: "transactions",
            element: <Transactions />,
          },
          {
            path: "transaction/details/:transactionId",
            element: <TransactionDetails />,
          },
          {
            path: "error404-page",
            element: <Error404 />,
          },
          {
            path: "customer-list",
            element: <CustomerList />,
          },
          {
            path: "customer-detail/:customerId",
            element: <CustomerDetail />,
          },
          {
            path: "brand-form",
            element: <BrandForm />,
          },
          {
            path: "home-layout",
            element: <HomeLayout />,
          },
          {
            path: "banners",
            element: <Banners />,
          },
          {
            path: "reviews",
            element: <Reviews />,
          },
          {
            path: "brands",
            element: <Brands />,
          },
          {
            path: "categories",
            element: <Categories />,
          },
          {
            path: "category-form",
            element: <CategoryForm />,
          },
          {
            path: "update-category/:categoryId",
            element: <UpdateCategoryForm />,
          },
          {
            path: "view-category/:categoryId",
            element: <ViewCategoryForm />,
          },
          {
            path: "settings",
            element: <Settings />,
          },
          {
            path: "admin-management",
            element: <AdminManagement />,
          },
          {
            path: "settings/edit-account",
            element: <EditAccount />,
          },
         
        ],
      },
      {
        path: "admin-login",
        element: <UserLogin />,
      },
      {
        path: "admin-registration",
        element: <UserRegistration />,
      },
    ],
  };
};
